import { render, staticRenderFns } from "./CurrentMentorship.vue?vue&type=template&id=2fb8fca0&scoped=true&"
import script from "./CurrentMentorship.vue?vue&type=script&lang=js&"
export * from "./CurrentMentorship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8fca0",
  null
  
)

export default component.exports